





























































































































import { PerformoTask, WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class ProcedureRowComponent extends Vue {
  @Prop({ required: true, default: undefined })
  private items!: PerformoTask[];
  @Prop({ default: 20 }) // default max visible items before scrolling
  private maxVisibleItems!: number;
  private prevDataEntry!: string;
  private ordersApi!: WorkordersApi;
  private loading = false;

  get formattedTasks() {
    if (!this.items) return '';
    var tasks = this.items;

    tasks.forEach((item) => {
      item.taskTextCalc = item.taskTextCalc?.replace(
        /(?:\r\n|\r|\n|\r\r)/g,
        '<br>'
      );
    });

    return tasks;
  }

  get shouldScroll() {
    return this.items && this.items.length > this.maxVisibleItems;
  }

  private onFocusHandler(data: string) {
    this.prevDataEntry = data;
  }

  private onBlurHandler(task: PerformoTask) {
    if (task.dataEntry != this.prevDataEntry) {
      this.taskDataEntry(task);
    }
  }

  private async toggleTaskDoneFlag(task: PerformoTask) {
    if (!task.workorderId || !task.taskId) {
      this.$emit(
        'taskUpdateError',
        'Error: Task missing workorderId or taskId.'
      );
      return;
    }
    this.loading = true;
    try {
      await this.ordersApi.workorderTaskDone({
        workorderId: task.workorderId,
        taskId: task.taskId,
        doneFlag: !task.doneFlag
      });
      this.$emit('taskUpdate');
    } catch (error) {
      this.$emit('taskUpdateError', error);
      this.$emit('taskUpdate');
    }
    this.loading = false;
  }

  private async toggleTaskFailedFlag(task: PerformoTask) {
    if (!task.workorderId || !task.taskId) {
      this.$emit(
        'taskUpdateError',
        'Error: Task missing workorderId or taskId.'
      );
      return;
    }
    this.loading = true;
    try {
      await this.ordersApi.workorderTaskFailed({
        workorderId: task.workorderId,
        taskId: task.taskId,
        failedFlag: !task.failedFlag
      });
      this.$emit('taskUpdate');
    } catch (error) {
      this.$emit('taskUpdateError', error);
      this.$emit('taskUpdate');
    }
    this.loading = false;
  }

  private async taskDataEntry(task: PerformoTask) {
    if (!task.workorderId || !task.taskId) {
      this.$emit(
        'taskUpdateError',
        'Error: Task missing workorderId or taskId.'
      );
      return;
    }

    this.loading = true;

    try {
      await this.ordersApi.workorderTaskDataEntry({
        workorderId: task.workorderId,
        taskId: task.taskId,
        dataEntry: task.dataEntry?.toString()
      });
      this.$emit('taskUpdate');
    } catch (error) {
      this.$emit('taskUpdateError', error);
      this.$emit('taskUpdate');
    }

    this.loading = false;
  }

  private async mounted() {
    // blank
  }
}
